/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from "react";
import {useSelectFileUploadResponse, useSelectWizardMetaData, useSliceActions} from "../../../../redux/ducks/Wizard/SliceProvider";
import {IBaseStepProps} from "../../../components/Wizard/types";
import Plotly3D from "../Plots/Plotly3D";
import TemplateStep from "../../../components/Wizard/Steps/TemplateStep";
import {useDispatch} from "react-redux";
import toast from "react-hot-toast";
import {usePostRequest} from "../../../../api/helper";
import {VEHICLE_PROGRAMS_CONSTANTS} from "../constants";
import useGetUrlParams from "../../../../hooks/useGetUrlParams";
import {setDevelopmentStagesTree} from "../../../../redux/ducks/VehicleProgramsDetails/slice";
import {setSensorBomIsReadOnly} from "../../../../redux/ducks/AdasPrograms/slice";

const Step3D = (props: IBaseStepProps) => {
  const {isLastWizardStep, messagesTitle} = props
  const dispatch = useDispatch()
  const {appendStepXErrorMessages, setWizardOpen, clearState, refreshTable} = useSliceActions()
  const stepIndex = isLastWizardStep ? 4 : 3
  const programCode = props?.programCode

  let cosmosData = useSelectFileUploadResponse()?.cosmos_data
  const wizardMetaData = useSelectWizardMetaData()
  cosmosData = {...cosmosData, ...wizardMetaData}
  cosmosData["id"] = props?.id
  cosmosData["new_max_version"] = props?.versionNumber
  const response = useSelectFileUploadResponse()
  const plotlyTraces = response

  const content2 = (
    <div>
      <Plotly3D plotlyTraces={plotlyTraces?.cosmos_data?.sensors_data_map}/>
    </div>
  )

  const url = VEHICLE_PROGRAMS_CONSTANTS.itemDetails.endpoints.addDevelopmentStageData
  const submitHandle = usePostRequest(url)
  // get vehicleProgramId from the url
  const {vehicleProgramId} = useGetUrlParams();

  const handleSubmit = async () => {
    const payload = {
      cosmosData,
      meta: {
        vehicleProgramId
      }
    }
    const adasProgramId = cosmosData?.metadata?.adasProgramId ?? false
    submitHandle(payload)
      .then(_response => {
        const _tree = _response?.tree
        const isSensorBomReadOnly = _response?.isSensorBomReadOnly
        if (_tree) {
          dispatch(setDevelopmentStagesTree(_response.tree))
          dispatch(setSensorBomIsReadOnly({adasProgramId, isReadOnly: isSensorBomReadOnly}))
        }
        dispatch(refreshTable())
        dispatch(setWizardOpen(false))
        dispatch(clearState())
      })
      .catch(error => {
        const errorMessage = error.statusText + ", please try again or contact support for assistance. Error on Vehicle Program Wizard Submission."
        toast.error(errorMessage);
        const msg = {text: errorMessage, color: '#FF0000'}
        dispatch(appendStepXErrorMessages([msg], stepIndex))
      })
  }

  return (
    <>
      <TemplateStep content1={null} content2={content2} errorMessages={[]}
                    messagesTitle={messagesTitle} isFirstWizardStep={false} isLastWizardStep={true}
                    customTopRow={null}
                    handleSubmit={handleSubmit} popupTitle={'Add Vehicle Program Data'} submitPopupEnabled={true}
                    submitDialogContentText={"Add vehicle coordinate and sensor position data for " + programCode}
      />
    </>
  );
};

export default Step3D